export default function HCPProduction() {
  return (
    <div>
      <h1>Produção HCP</h1>
      <p>Gerenciamento de produção do HCP.</p>
    </div>
  );
}
